import {
  BadgeCheck,
  Calendar,
  ClipboardCheck,
  ClipboardList,
  FilePen,
  FileText,
  MessageSquare,
  Phone,
  Receipt,
  Users,
} from 'lucide-react';

import { TaskType } from 'common-src/models/PatientTask/constants';

const DURATION_TYPE_BY_TASK_TYPE_ID = {
  [TaskType.ScheduleVisit.value]: 'schedule',
  [TaskType.RescheduleVisit.value]: 'schedule',
  [TaskType.BillingAndInsurance.value]: 'billing',
  [TaskType.MemberPortal.value]: 'message',
  [TaskType.Engagement.value]: 'outreach',
  [TaskType.CareCoordinationCaregiverOutreach.value]: 'outreach',
  [TaskType.Cognitive.value]: 'assessment',
  [TaskType.AthenaIntegration.value]: 'verify',
  [TaskType.Labs.value]: 'order',
  [TaskType.Compliance.value]: 'verify',
  [TaskType.SocialWorkReferral.value]: 'order',
  [TaskType.CareCoordination.value]: 'call',
  [TaskType.CGM.value]: 'review',
  [TaskType.BGM.value]: 'review',
  [TaskType.StarRatings.value]: 'review',
  [TaskType.Administrative.value]: 'document',
  [TaskType.Diabetes.value]: 'review',
  [TaskType.GUIDE.value]: 'review',
  [TaskType.PreVisitIntake.value]: 'intake',
};

const ICON_BY_DURATION_TYPE = {
  call: Phone,
  message: MessageSquare,
  assessment: ClipboardCheck,
  review: FileText,
  verify: BadgeCheck,
  schedule: Calendar,
  order: ClipboardList,
  document: FilePen,
  billing: Receipt,
  outreach: Users,
  intake: ClipboardList,
};

export const getTaskTypeIcon = (task) => {
  const typeId = task?.typeId ?? task?.type_id;
  const durationType = DURATION_TYPE_BY_TASK_TYPE_ID[typeId];
  return (durationType && ICON_BY_DURATION_TYPE[durationType]) || null;
};
